import amplitude, { AmplitudeAnalytics } from './wrapper'
import { AMPLITUDE_INSTANCE_KEY, AMPLITUDE_LIBRARY_URL } from '../../../constants'
import { preload } from '../../../utils'

export const AMPLITUDE_USER_PLAYBACK_INITIATED = 'User_Playback_Initiated'
export const AMPLITUDE_USER_CONTENT_PLAYED = 'User_Content_Played'

export const enum CONTENT_TYPE {
  AUDIO = 'audio',
  VIDEO = 'video'
}

export const enum APPLICATION_STATE {
  FOREGROUND = 'foreground',
  BACKGROUND = 'background'
}

export const enum STOP_REASON {
  TRACK_SKIP = 'track skip',
  TRACK_END = 'track end'
}

function preloadAmplitudeScript() {
  return preload(AMPLITUDE_LIBRARY_URL)
}

async function initAmplitude(userId?: string, key: string = AMPLITUDE_INSTANCE_KEY) {
  return await amplitude.init(userId, key)
}

export { AmplitudeAnalytics, initAmplitude, preloadAmplitudeScript }

export default amplitude
